import React from 'react';
import { ConflictEffectProps } from '../types';

/**
 * ConflictEffect component for managing policy conflict resolution
 * 
 * This component provides a dropdown interface for selecting how policy conflicts
 * should be handled. It supports three modes:
 * - audit: Log conflicts but don't enforce
 * - deny: Block conflicting operations
 * - disabled: Ignore conflicts
 * 
 * @example
 * <ConflictEffect
 *   conflictEffect="audit"
 *   onUpdateEffect={handleEffectChange}
 * />
 */
export const ConflictEffect: React.FC<ConflictEffectProps> = ({
  conflictEffect,
  onUpdateEffect
}) => {
  return (
    <div className="mb-4">
      <label className="block text-sm font-medium text-gray-900 dark:text-gray-100 mb-1">Conflict Effect</label>
      <select
        value={conflictEffect || ''}
        onChange={(e) => {
          if (e.target.value) {
            onUpdateEffect(e.target.value);
          } else {
            onUpdateEffect(undefined);
          }
        }}
        className="mt-1 block w-full pl-3 pr-10 py-2 text-base border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-900 text-gray-900 dark:text-gray-100 rounded px-3 focus:outline-none focus:ring-2 focus:ring-blue-500 sm:text-sm"
      >
        <option value="">Select Effect</option>
        <option value="audit">Audit</option>
        <option value="deny">Deny</option>
        <option value="disabled">Disabled</option>
      </select>
    </div>
  );
}; 